export class StyleConstants {
  public static readonly OVERFLOW_HIDDEN_CLASS = "overflow-hidden";

  public static readonly FONT_SIZE_H2 = "24px";

  public static readonly FONT_SIZE_BODY3 = "12px";
}
